<template>
  <v-container fluid class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="10" class="headline pb-0 pt-0">
        Sign In Sheets
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-date-picker
          color="primary"
          v-model="date"
          full-width
        ></v-date-picker>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <h3 class="title">View sign in sheet uploads.</h3>
        <div class="subheading mb-4">
          Choose a date on the calendar, then click the button below.
        </div>
        <v-btn @click="getUploads" color="primary">
          <v-icon left>description</v-icon>Get Sign In Sheets
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" v-if="this.signInSheets.length">
        <h3 class="headline mb-2">
          <span class="font-weight-bold">{{
            signInSheets[0].photos[0].date | moment("MMM Do YYYY")
          }}</span>
          -
          <span class="font-weight-regular">Uploaded Sign In Sheets</span>
        </h3>
        <v-card>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="320">Job Site</th>
                  <th class="text-left">Uploads</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sheet in signInSheets" :key="sheet.id">
                  <td class="py-2" valign="top">
                    <div
                      class="ma-0 pa-0 body-2 font-weight-bold"
                      style="line-height:1.4em"
                    >
                      {{ sheet.street }}
                      <span class="font-weight-regular">
                        {{ sheet.street2 }}</span
                      >
                    </div>
                    <div class="caption grey--text">
                      {{ sheet.city }} {{ sheet.postalCode }}
                    </div>
                    <div class="caption blue--text text--darken-4">
                      Job ID:
                      <strong>{{ sheet.jobId }} </strong>
                      <span
                        v-if="sheet.department"
                        style="text-transform:uppercase"
                      >
                        {{ sheet.department.join(", ") }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span
                      v-for="(photo, ix) in sheet.photos"
                      :key="ix"
                      class="mr-1 mb-1"
                    >
                      <a target="_blank" :href="photo.url">
                        <v-img
                          lazy-src="https://placehold.jp/100x100.png"
                          :src="
                            photo.url.replace(
                              'https://firebasestorage.googleapis.com/',
                              'https://ik.imagekit.io/albademo/tr:w-100/'
                            )
                          "
                          height="100"
                          width="100"
                          style="display:inline-block"
                          class="ma-2"
                        />
                      </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
      <div
        v-if="!this.signInSheets.length"
        class="pa-4 grey--text text--darken-2"
      >
        {{ fetchingMessage }}
      </div>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      jobSite: null,
      date: moment().format("YYYY-MM-DD"),
      pickerDate: null,
      signInSheets: [],
      fetchingMessage: "Select a date, then click GET SIGN IN SHEETS button.",
    };
  },
  async created() {},
  computed: {
    ...mapState({
      jobSites: (state) => state.jobSites,
    }),
  },
  methods: {
    async getUploads() {
      try {
        this.signInSheets = [];
        const photosRes = await fb.db
          .collection("dailyReportPhotos")
          .where("date", "==", moment(this.date).format("YYYY-MM-DD"))
          .where("photoType", "==", "Sign In Sheets")
          .get();
        let photos = [];
        photosRes.forEach((u) => {
          photos.push({
            id: u.id,
            ...u.data(),
          });
        });
        const jobSites = this.jobSites.filter((j) => {
          return photos.map((p) => p.jobSiteId).includes(j.id);
        });
        let signInSheets = jobSites.map((j) => {
          return {
            ...j,
            photos: photos.filter((p) => p.jobSiteId === j.id),
          };
        });
        if (!signInSheets.length) {
          this.fetchingMessage = `*No uploaded sign in sheets found for ${moment(
            this.date
          ).format("MMM Do YYYY")}.`;
          return;
        }
        this.signInSheets = signInSheets;
      } catch (err) {
        console.log(err.message);
        alert("Error getting orders");
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
